
import { reactive, computed, SetupContext } from 'vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'

export default {
  name: 'FormAreaCheckbox',

  components: {
    CheckboxButton
  },

  props: {
    label: String,
    items: Array,
    id: {
      type: String,
      required: true
    },
    enableAllCheck: {
      type: Boolean,
      default: true
    },
    titleHasBorder: {
      type: Boolean,
      default: false
    },
    variableSize: {
      type: Boolean,
      default: false
    },
    gatAllOnce: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const state = reactive({
      isExpand: false
    })

    const handleToggle = (ev: any) => {
      state.isExpand = state.isExpand ? false : true

      const next = ev.target.nextElementSibling
      const height = next.firstElementChild.clientHeight + 20

      next.style.height = state.isExpand ? height + 'px' : '0'
    }

    const status = computed(() => {
      const selectedItems = props.items.filter((item: any) => {
        return item.checked
      })

      if (selectedItems.length === props.items.length) return '全て選択'
      if (selectedItems.length > 0) return '選択中'
      return '未選択'
    })

    const checkAll = (ev: any) => {
      const selectedItems = props.items.filter((item: any) => {
        return item.checked
      })

      // 全て選択されていたら全て解除
      // それ以外は全て選択
      if (props.gatAllOnce) {
        // 一度でtrue/falseを送る
        context.emit(
          'select-area',
          selectedItems.length === props.items.length ? false : true
        )
      } else {
        // 都道府県の分だけemit実行
        props.items.forEach((item: any) => {
          context.emit('check-prefecture', {
            value: item.value,
            checked: selectedItems.length === props.items.length ? false : true
          })
        })
      }
    }

    const checkSingle = (ev: any) => {
      context.emit('check-prefecture', ev)
    }

    return {
      state,
      status,
      handleToggle,
      checkAll,
      checkSingle
    }
  }
}
